module.exports = __webpack_public_path__ + "static/media/SFST_1-763w.9a1d5998.webp";